import apis from '../request/apis';
import axios from "axios";
import store from '../store';
import messageVue from '../components/api/message.vue';
import router from '@/router/index'

let is_show = true

const utils = {
    // 设计稿高度转vw
    pt(number, isNumber = false) {
        const f = number / 375 * 100;
        return isNumber? f : `${f}vw`;
    },

    // 实际px转设计稿px
    px(number) {
        const sw = document.body.clientWidth;
        const f = number * 375 / sw;
        return parseFloat(f);
    },

    // 设计稿px转实际px
    actualPx(number) {
        const sw = document.body.clientWidth;
        const f = number * sw / 375;
        return parseFloat(f);
    },

    // vw转实际px
    vPx(number) {
        const sw = document.body.clientWidth;
        const f = number * sw / 100;
        return Number(f);
    },

    message(Vue, text, duration = 3000) {
        let middle = false;
        let loginMsg = false;

        if(typeof text == 'object') {
            middle = text.middle;
            loginMsg = text.loginMsg;
            text = text.text;
        }

        let messageCom = messageVue.$create({
            $props: { text, middle, loginMsg }
        }).show();
        setTimeout(() => {
            messageCom.remove();
        }, duration)
    },

    // 获取案例分类
    getCaseType() {
        return new Promise((resolve, reject) => {
            const arr = store.state.cases.type;
            if(arr.length) {
                resolve(arr);
            } else {
                store.dispatch("cases/getCaseType").then(res => {
                    resolve(res);
                }).catch(err => {
                    reject(err);
                })
            }
        })

    },

    // 获取品牌分类
    getBrandType() {
        const arr = store.state.brand.type;
        if(arr.length) {
            return Promise.resolve(arr);
        } else {
            return new Promise((resolve, reject) => {
                store.dispatch("brand/getBrandType").then(res => {
                    return resolve(res);
                })
            })

        }
    },

    /**
     *
     * @param {*} str
     * @param {*} type
     * @param {*} scale scale等于none则不调整尺寸
     * @param {*} width
     * @returns
     */
    setSourcePath(str, type, scale, width) {
        if(!str) {
            switch(type) {
                case 0: return require("@/assets/img/user_pic_01.png");
                case 1: return require("@/assets/img/seatPicCase.png");
                case 2: return require("@/assets/img/seatPicProduct.png");
                case 3: return require("@/assets/img/seatPicBrand.png");
                default: return ''
            }
        }
        str = str.toString();
        if(str.includes('http://') || str.includes('https://')) {
            return str;
        }else if(str) {
            if(str[0] == '/') str = str.slice(1)
            // return store.state.baseUrl + "/sd_smi/uploads/" + str;
            // return "https://minio-test.twyfordtile.top/"  + str;
            const IMAGE_EXTENSIONS = [
              'jpg', 'jpeg', 'png', 'gif', 'bmp',
              'webp', 'heic', 'heif', 'svg', 'tiff'
            ];
            const imgRegex = new RegExp(
              `\\.(${IMAGE_EXTENSIONS.join('|')})(?<![?#]|\\/)$`,
              'i'
            );
            // 不是图片，使用非压缩域名
            if(!imgRegex.test(str)) {
              return process.env.ATTACHMENT_DOMAIN + '/' + str
            }

            const url = process.env.IMAGE_DOMAIN + '/' + str
            const urlObj = new URL(url)

            if (scale !== 'none') {
              urlObj.searchParams.append('width', width || Math.floor(window.innerWidth * (scale || 1)))
            }
            // 暂不调整，实测发现avif体积更小，但加载更慢。考虑解码快
            // // s3支持返回最优格式
            // urlObj.searchParams.append('format', 'auto')
            if(window.supportWebp) {
              urlObj.searchParams.append('format', 'webp')
            }

            return urlObj.toString();
            // return "https://d15rsl9dupihh.cloudfront.net/" + str;
            // return "https://prod-af-south-1-vosa.s3.af-south-1.amazonaws.com/" + str;
        }

    },

    setSourcePathTwo(str, type) {
        if(!str) {
            switch(type) {
                case 0: return require("@/assets/img/user_pic_01.png");
                case 1: return require("@/assets/img/seatPicCase.png");
                case 2: return require("@/assets/img/seatPicProduct.png");
                case 3: return require("@/assets/img/seatPicBrand.png");
                default: return ''
            }
        }
        str = str.toString();
        if(str.includes('http://') || str.includes('https://')) {
            return str;
        }else if(str) {
            if(str[0] == '/') str = str.slice(1)
                if (is_show) {
                    is_show = false;
                    // return "https://prod-af-south-1-vosa.s3.af-south-1.amazonaws.com/" + str;
                    return "https://prod-af-south-1-vosa.s3.af-south-1.amazonaws.com/" + str;
                } else {
                    return "https://d15rsl9dupihh.cloudfront.net/" + str;
                }
        }

    },

    getUserHeadImg() {
        let userinfo = store.state.user.userinfo;
        if(userinfo.headimg) {
            return this.setSourcePath(userinfo.headimg, 0)
        }else {
            return require('@/assets/img/user_pic_01.png');
        }
    },

    copy(that, src, onBeforeCopy) {
        var textareaC = document.createElement('textarea');
        textareaC.setAttribute('readonly', 'readonly'); //设置只读属性防止手机上弹出软键盘
        let url = src || window.location.href;
        if(store.getters.isLogin) {
            url += `${url.includes('?')? '&' : '?'}` + 'client_user_id='+store.state.user.userinfo.user_id;
        }
        // onBeforeCopy
        if(onBeforeCopy && (typeof onBeforeCopy == 'function')) {
            url = onBeforeCopy(url);
        }
        textareaC.value = url;
        document.body.appendChild(textareaC); //将textarea添加为body子元素
        textareaC.select();
        var res = document.execCommand('copy');
        document.body.removeChild(textareaC);//移除DOM元素
        this.message(that, "Copy Successfully");
    },

    firstToUpper(str) {
        if(str && (typeof str == 'string')) {
            return str.toLowerCase().replace(/( |^)[a-z]/g,(L)=>L.toUpperCase());
        }else {
            return str
        }
    },

    getPosition() {
        return new Promise((resolve, reject) => {
            console.log(store.state.common.position.latitude)
            if(store.state.common.position.latitude) {
                axios.get(`https://maps.google.com/maps/api/geocode/json?latlng=${store.state.common.position.latitude + "," + store.state.common.position.longitude}&language=en-us&sensor=false&key=${store.state.google_api_key}`, {timeout: 5000}).then(res => {
                    console.log(res)
                    if(res.data && res.data.status == "OK") {
                        let results = res.data.results, country, city;
                        results.forEach(item => {
                            if(item.types.includes('country')) {
                                country = item.address_components.find(address => {
                                    return address.types.includes('country')
                                })
                            }
                            if(item.types.includes('locality')) {
                                city = item.address_components.find(address => {
                                    return address.types.includes('locality')
                                })
                            }
                        })

                        country = country.long_name;
                        city = city.long_name;
                        console.log(country, city)
                        store.commit("changePosition", [country, city])
                        resolve({country, city});
                        // this.getAllCity()
                    }else {
                        resolve(false)
                    }
                }).catch(err => {
                    resolve(false)
                })
            }
        })
    },

    setWeekStr(item) {
        console.log(item)
        let weeks = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
        let businessDays = [];
        let x = [], y = [], continuity = 0;
        for(var index in weeks) {
            let day = weeks[index];
            if(item[`isRest${day}`] == '2') {
                x.push(index)
                businessDays.push(this.$t('text.'+day.toLowerCase()));
            }else {
                y.push(index)
            }
        }
        x.forEach((j, i) => {
            if(i != 0 && (j != (Number(x[i-1])+1))) {
                continuity = 1;
                return y.forEach((j, i) => {
                    if(i != 0 && (j != x[i]+1)) {
                        return continuity = 2;
                    }
                })
            }
        })
        switch(continuity) {
            case 0: return `${businessDays[0]} to ${businessDays[businessDays.length-1]}`;
            case 1: return `${businessDays[0]} to ${businessDays[businessDays.length-1]}`;
            case 2: return businessDays.join(',');
        }
    },

    setTimeStr(time) {
        let timeArr = time.split(":");
        let hour = Number(timeArr[0]);
        let isAm = hour <= 12;
        hour = isAm? hour : hour-12;
        if(hour < 10) hour = '0'+hour
        return `${hour}:${timeArr[1]}${isAm? 'a' : 'p'}.m.`;
    },

    getPositionLa() {
        return new Promise((resolve, reject) => {
            if (navigator.geolocation){　　
                console.log("开始获取定位")
                navigator.geolocation.getCurrentPosition(location => {
                    console.log("成功获取定位");
                    resolve(location.coords)
                }, err => {
                    console.log("定位出错", err)
                    reject();
                }, {
                    // timeout: 5000,
                    enableHighAccuracy: true // 高精度定位
                });　　
            }else{　　
                console.log("浏览器不支持地理定位。");　　
                reject();
            }
        })
    },

    toLogin() {
        let current = router.history.current;
        store.commit('saveCurrent', current);
        router.replace({
            path: '/login'
        });
    },

    toIndex() {
        router.replace({
            path: "/"
        })
    },

    toChangeCountry() {
        router.push({
            path: "/countrys"
        })
    },

    async back() {
        console.log("统一调度back");
        let routerHistory = store.state.routerHistory;
        if(routerHistory.length) {
            if (router.currentRoute.query.lang||router.currentRoute.query.tenantId) {
                if (router.currentRoute.path == '/setting-info') {
                    router.push({
                        path: '/setting',
                        query: router.currentRoute.query
                    })
                }else if (router.currentRoute.path == '/setting') {
                    router.push({
                        path: '/person',
                        query: router.currentRoute.query
                    })
                } else {
                    store.commit("common/changeIsBack", true);
                    router.go(-1);
                }
            }else{
                store.commit("common/changeIsBack", true);
                router.go(-1);
            }
        }else {
            let path = "/";
            router.push({path});
            return;
            let pageName = router.currentRoute.name;
            if(pageName.toLowerCase().includes("case")) {
                path = "/cases"
            }else if(pageName.toLowerCase().includes("product")) {
                path = "/product"
            }

            router.push({path})
        }
    },

    isIosDevice() {
        var  u  =  navigator.userAgent, app  =  navigator.appVersion;
        var  ios  =  !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
        var  iPad  =  u.indexOf('iPad')  >  -1;
        var  iPhone  =  u.indexOf('iPhone')  >  -1  ||  u.indexOf('Mac')  >  -1;
        return (ios  ||  iPad  ||  iPhone)? true : false;
    },

    // 检验密码格式
    checkPassword(password) {
        let msg = '';
        if(password.length < 6 || !(/^[\d^A-Z]+$/i.test(password)) || password.toUpperCase() == password) {
            msg = "The password must contain uppercase and lowercase letters and numbers, and cannot have special symbols.";
        }
        return msg;
    }
}

export default utils;


export function getTenantId() {
  return store.state.common.datacenteruuid
}

export function checkTenantId() {
  const tenantId = getTenantId()
  if(!tenantId) {
    router.push({
      path: "/countrys",
      query:{
        force:1,
        redirectUrl: location.href
      }
  })
  }
}

// getShareUrl({
//   title: 'Product',
//   desc: 'Raw Brutalist III, PMCP42094T 3D WALL TILE 2540 15PCS T1',
//   image:
//     'https://vosa-cp-s3.twyfordtile.net/vosa-test/upload/20250605/0f7633078222749ceca719bf900ec217.jpg?width=600&format=webp',
//   pageUrl:
//     'https://vosa-h5.twyfordtile.net/#/product-detail?id=1931720812260253698',
// })
export function getShareUrl(params = {}) {
  let template =
    process.env.SHARE_DOMAIN + '/sd_smi/api/v1/Web_Product/whatsapp-share?title={title}&desc={desc}&image={image}&pageUrl={pageUrl}'

  const keys = ['title', 'desc', 'image', 'pageUrl']

  keys.forEach((key) => {
    template = template.replace(
      `{${key}}`,
      encodeURIComponent(params[key] || '')
    )
  })

  console.log('shared url: ', template)
  return template
}




// WEBPACK FOOTER //
// ./src/utils/index.js